import { render, staticRenderFns } from "./AuctionItemCard.vue?vue&type=template&id=67d087eb&scoped=true&lang=pug"
import script from "./AuctionItemCard.vue?vue&type=script&lang=ts"
export * from "./AuctionItemCard.vue?vue&type=script&lang=ts"
import style0 from "./AuctionItemCard.vue?vue&type=style&index=0&id=67d087eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d087eb",
  null
  
)

export default component.exports